if not App.angularApp?
    return

###
mf-popover-validate displays of backend validation on the frontend.
This allows us to define uniform validation in just one location.

To use:
1) apply directive to input
2) input must be in a <form>
3) input must have an id
4) front end must extend Angular/Controller (adds validationErrors and validate stub)
5) `pretend` must be passed when saving
6) save function must handle 422 error and set validationErrors

Example of save function

>   save: (pretend = false) =>
>        @scope.$emit 'save' if not pretend
>        @service.save(pretend, save_data)
>       .then (response) =>
>            @scope.validationErrors = null
>            @closeWithAlert(response.data.status) if not pretend
>        .catch (response) =>
>            if response.status is 422
>                @scope.validationErrors = response.data
>            @q.reject()

NOTE: directive doesn't detect change if the input is using ui-mask.
You must manually specify ng-change='save(pretend)'
###
App.angularApp.directive 'mfPopoverValidate', ['$rootScope', '$compile', ($rootScope, $compile) ->
    return {
        restrict: 'A'
        replace: false
        terminal: true
        priority: 1000
        link: (scope, element, attrs, ctrl) =>
            name = attrs.mfPopoverValidate or attrs.ngModel
            placement = attrs.errorPlacement or 'right'

            if not name?
                throw new Error 'Element with mf-popover-validate must specify ng-model or define the key on scope.validationErrors to watch!'

            if not element.attr('id')?
                throw new Error 'Element with mf-popover-validate must specify an id'

            if element.attr('id') and not element.attr('name')
                element.attr('name', element.attr('id'))

            # Find the form element
            element.parent().addClass('error-tooltip-container')
            form = element.closest('form')

            if not form?
                throw new Error 'You must use mf-popover-validate inside a <form> with a name'

            formScope = form.scope()
            formName = form.attr 'name'

            if not formName?
                throw new Error 'You must use mf-popover-validate inside a <form> with a name'

            # popover name needs to be unique but we need to handle nested models
            # solution: replace '.' with '_' (e.g. 'user.name' is distinct from 'username')
            tooltip_name = name.replace /[\.]+/g, '_'

            # Add the template for this input if we haven't already done it
            if element.parent().find("#mfPopoverErrorTemplate#{tooltip_name}.html").length is 0
                template = angular.element "
                    <script type='text/ng-template' id='mfPopoverErrorTemplate#{tooltip_name}.html'>
                        <span class='mf-popover-validate-css'>
                            <% validationErrors['#{name}'].join(' ') %>
                        </span>
                    </script>
                "
                element.after template
                $compile(template)(scope)

            # Set up popover validation
            scope["mfPopoverErrorTemplate#{tooltip_name}"] = "mfPopoverErrorTemplate#{tooltip_name}.html"
            element.attr 'uib-tooltip-template', "<% 'mfPopoverErrorTemplate#{tooltip_name}' %>"
            element.attr 'tooltip-trigger', 'mouseenter'
            element.attr 'tooltip-placement', placement
            element.attr 'tooltip-enable', "validationErrors['#{name}'] !== undefined"

            # Pretty validation on the input itself
            scope.$watch "validationErrors['#{name}']", (newValue, oldValue) =>
                if formScope[formName][name].$pristine
                    # If we haven't touched the input yet, don't show the validation error
                    delete scope.validationErrors?[name]
                    return

                if newValue isnt oldValue and newValue
                    element.addClass 'mfvalidate-invalid'
                else
                    element.removeClass 'mfvalidate-invalid'

            # Fire an event every time the input is changed
            element.on 'change', () =>
                scope.$emit 'mf-validate'

            # Dirty the input if we attempted to save the form
            $rootScope.$on 'save', () =>
                formScope[formName][name].$setDirty()

            element.removeAttr 'mf-popover-validate'
            element.removeAttr 'data-mf-popover-validate'

            $compile(element)(scope)
    }
]
